import { fields } from '@synergy/utils';

import { PurchaseOrderItem } from '../../../models/purchase-order-item';

export interface PurchaseOrderDetailPositionsFormValues {
    currency?: string;
    allItems: PurchaseOrderItem[];
    netShippingCosts: number;
    netSurcharge: number;
    isTaxFree: boolean;
    tax: number;
}

export const fieldNames = fields<PurchaseOrderDetailPositionsFormValues>();
export const fieldNamesItems = fields<PurchaseOrderItem>();
